"use client";

import { usePathname } from "next/navigation";

export function HomeOffer({ price, trialLabel }: { price: string; trialLabel: string }) {
  const pathname = usePathname();
  if (pathname !== "/") {
    return null;
  }

  return (
    <p className="text-[13px] leading-5 text-[var(--m-muted)] lg:shrink-0 lg:text-right">
      Sverim Pro — {price} / год
      <span className="mt-1 block">{trialLabel} бесплатно</span>
    </p>
  );
}
